import React from 'react'

import classes from './LegalPageLead.module.scss'

export default ({ children }) => {
  return <p className={classes.lead}>{children}</p>
}
